import { Button } from "@mui/material";

const RefreshPostgresEntitiesCacheButton = ({ handleOnClick }) => {
  return (
    <Button
      variant="outlined"
      onClick={handleOnClick}
      sx={{ backgroundColor: "lightblue" }}
    >
      Refresh Postgres Entities Cache
    </Button>
  );
};

export default RefreshPostgresEntitiesCacheButton;

